<!-- Customer Search -->
<p-dialog id="cais-customer-search" [(visible)]="caisServiceService.isDisplayCustomerSearchList" header="Customer Search" icon="pi pi-exclamation-triangle"
    width="auto" height="auto" [minY]="100" showEffect="fade" [modal]="true" (onHide)="caisServiceService.isDisplayCustomerSearchList = false;"
    [style]="{'width': '70%', 'min-width': '500px', 'top': '100px'}" [position]="'top'"  appendTo="body" [closable]="true" [maximizable]="true" [baseZIndex]="10000" draggable="true"
    styleClass= "customber-search-dialog" [focusOnShow]="false">
  <div class="col-lg-12">&nbsp;</div>
  <div class="ui-grid-col-12 nopadding">
    @if(isLoadingResults){
    <div class="example-loading-shade">
      <mat-spinner></mat-spinner>
    </div>
    }
    <!-- Customer List Data-View -->
      <p-table #dt 
        [columns]="cols" [value]="customers" selectionMode="single" [(selection)]="selectedCustomer" appendTo="body" 
        [totalRecords]="totalRecords" (onPage)="changePage($event)" [paginator]="true" alwaysShowPaginator="true" paginatorPosition="both" showCurrentPageReport="true" 
        [rows]="rowcount" [pageLinks]="rowcount" [lazy]="true" 
        dataKey="id" styleClass = "customer-search-table">
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns && columns.length+1" class="text-center">
              {{tbldatamsg}}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="caption">
          <div class="customer-search-field-panel">
            <p-autoComplete styleClass = "search-autocomplete" [(ngModel)]="customerKeyword" size="large" placeholder="Customers" [minLength]="1" 
              [suggestions]="customerDetails" (completeMethod)="filterCustomer($event)"></p-autoComplete>
            <button pButton id="customerSearchBtn" type="button" icon="pi pi-search" class="button customer-search-button btn-lg" (click)="getAllCustomers();"></button>
          </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th id="action" style="width: 3em"></th>
            @for(col of columns; track col.header + '-'+ $index; let idx = $index) {
            <th [id]="col.header" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':''">
              {{col.header}}
            </th>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-columns="columns">
          <tr [pSelectableRow]="rowData">
            <td>
              <a href="#" [pRowToggler]="rowData">
                <em [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></em>
              </a>
            </td>
            @for(col of columns; track col.field + '-'+ $index; let idx = $index) {
            <td [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':''">
              {{rowData[col.field]}}
            </td>
            }
          </tr>
        </ng-template>
        <ng-template #expandedrow let-rowData let-columns="columns">
          <tr>
            <td [attr.colspan]="columns.length + 1">
              <div class="ui-g ui-fluid">
                <div class="ui-g-12 ui-md-1" style="text-align:center"></div>
                <div class="ui-g-12 ui-md-11">
                  <!-- Legal Entity -->
                   @if(selectedCustomerType === this.constantService.customerTypes[0]){
                  <div class="ui-g">
                    <div class="ui-g-12">
                      <strong>Natural Person:</strong> {{rowData.firstName.concat(' ', rowData.middleName, ' ', rowData.lastName)}}
                    </div>
                    <div class="ui-g-12">
                      <strong>In Customer RecordID:</strong> {{rowData.inCustomerRecordID}}
                    </div>
                    <div class="ui-g-12">
                      <strong>Tid Type:</strong> {{rowData.tidType}}
                    </div>
                    <div class="ui-g-12">
                      <strong>Tid Value:</strong> {{rowData.tidValue}}
                    </div>
                  </div>
                  }
                  <!-- Natural Person -->
                   @if(selectedCustomerType === this.constantService.customerTypes[1]){
                  <div class="ui-g">
                    <div class="ui-g-12">
                      <strong>Legal Entity:</strong> {{rowData.legalName}}
                    </div>
                    <div class="ui-g-12">
                      <strong>In CustomerSearch ID:</strong> {{rowData.inCustomerRecordID}}
                    </div>
                    <div class="ui-g-12">
                      <strong>Tid Type:</strong> {{rowData.tidType}}
                    </div>
                    <div class="ui-g-12">
                      <strong>Tid Value:</strong> {{rowData.tidValue}}
                    </div>
                  </div>
                  }
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    <!-- End of Customer List Data-View -->
  </div>
  <div class="col-lg-12">&nbsp;</div>
    <ng-template #footer>
    <p-button type="button" id="cais-customer-submit" icon="fa fa-check" class="ui-button-secondary customer-footer-button" (click)="selectedCustomer && this.selectConfirmCustomer.emit(selectedCustomer);caisServiceService.isDisplayCustomerSearchList = false;" label="Confirm Customer"></p-button>
    <p-button type="button" id="cais-customer-search-close" (click)="caisServiceService.isDisplayCustomerSearchList = false;" 
      label="Close" icon="fa fa-close" class="ui-button-secondary customer-footer-button">
    </p-button>
    </ng-template>
</p-dialog>